import Vue, { Component } from 'vue';
import LivePreview from '@/modules/code/components/live-preview/live-preview.vue';
import FeatureVersionValidator from '@/components/feature-version-validator/feature-version-validator.vue';
import CodePreview from '@/modules/code/components/code-preview/code-preview.vue';
import PropsTable from '@/components/props-table/props-table.vue';
import { VueConstructor } from 'vue/types/umd';
import Feature from '@/modules/featuring/components/feature/feature.vue';
import CodeEditor from '@/modules/code/components/code-editor/code-editor.vue';

/**
 * Registers global component used for documentation
 */
type MarkupComponents = Array<{
    name: string;
    class: VueConstructor<Vue>;
}>;

const markupComponents: MarkupComponents = [
    {
        class: PropsTable,
        name: 'props-table'
    },
    {
        class: LivePreview,
        name: 'live-preview'
    },
    {
        class: CodePreview,
        name: 'code-preview'
    },
    {
        class: FeatureVersionValidator,
        name: 'feature-version-validator'
    },
    {
        class: CodeEditor,
        name: 'code-editor'
    },
    {
        class: Feature,
        name: 'feature'
    }
];

const registerMarkupComponents = (components: MarkupComponents) => {
    components.forEach((component) => {
        Vue.component(component.name, component.class);
    });
};

export const registerComponents = () => {
    registerMarkupComponents(markupComponents);
};
